import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import PlatFormAPIAxiosInstance from "../utils/platFormAxios";
import { useTrialsRouter } from "./useTrialsRouter";
import { type NutrientCatalogProduct } from "../utils/nutrientCalculation";

export type { NutrientCatalogProduct } from "../utils/nutrientCalculation";

const useNutrientCatalog = (
  orgId: string | undefined,
  country: string | undefined
): UseQueryResult<NutrientCatalogProduct[], Error> => {
  const { workspaceId } = useTrialsRouter();

  return useQuery<NutrientCatalogProduct[], Error>({
    queryKey: ["ratesDosageNutrientCatalog", orgId, workspaceId, country],
    enabled: Boolean(orgId && country),
    queryFn: async ({ signal }) => {
      try {
        if (!orgId || !country) {
          throw new Error(
            "Missing organization or country for the fertilizer catalogue."
          );
        }
        const response = await PlatFormAPIAxiosInstance.get<{
          content?: NutrientCatalogProduct[];
        }>(
          `/catalog/orgs/${orgId}/fertilizers?country=${encodeURIComponent(
            country
          )}&full=true&include_hidden=true&size=100`,
          { signal }
        );
        return response.data.content ?? [];
      } catch (error) {
        console.error(
          "Error fetching the Nutrients fertilizer catalogue:",
          error
        );
        throw error;
      }
    },
    retry: false,
  });
};

export default useNutrientCatalog;
